<template>
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.23 7.21a.75.75 0 0 1 1.06.02L10 9.94l2.71-2.71a.75.75 0 1 1 1.06 1.06l-3.24 3.25a.75.75 0 0 1-1.06 0L6.25 8.29a.75.75 0 0 1-.02-1.08z" />
    </svg>
</template>

<script>
export default {
    name: 'ChevronIcon'
};
</script>
